export const PatientDispensePrescriptionsPage = () => (
  <h1>Dispense prescriptions</h1>
);
